import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {Checkbox} from "semantic-ui-react";
import {Link} from "react-router-dom";
import MARVEL from "../../../common/utils/MarvelUrls";
import {CountrySortFields} from "../constants/CountriesActionConstants";
import LastUpdated from '../../../common/partials/LastUpdated/LastUpdated';

export class CountriesListRow extends React.Component {

    static propTypes = {
        countryID: PropTypes.string,
        countryName: PropTypes.string,
        countryISO: PropTypes.string,
        kycStatus: PropTypes.string,
        kycTier: PropTypes.number,
        number_2x2_support: PropTypes.bool,
        ageSupport: PropTypes.bool,
        bvSupport: PropTypes.bool,
        bvPlusSupport: PropTypes.bool,
        number_1x1_match_rate: PropTypes.number,
        number_2x2_match_rate: PropTypes.number,
        lastUpdated: PropTypes.string
    }

    get checkbox() {
        return (
            <td className="low-width">
                <Checkbox disabled/>
            </td>
        );
    }

    get countryName() {
        const { countryName, countryISO, countryID, countriesSortKey } = this.props;
        let classnames = ""
        if (countriesSortKey === CountrySortFields.COUNTRY_NAME) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <Link to={{pathname: MARVEL.VERITAS.country_coverage + countryID}} key={countryID}>
                    <p>{countryName} ({countryISO})</p>
                </Link>
            </td>
        );
    }

    get kycSupport() {
        const { number_2x2_support, ageSupport } = this.props;
        // by default we have 1x1 kyc product support for every country we add.
        let kycSupportString = '1x1';

        if (number_2x2_support && ageSupport) {
            kycSupportString += ', 2x2 & Age';
        } else if (number_2x2_support) {
            kycSupportString += ' & 2x2';
        } else if (ageSupport) {
            kycSupportString += ' & Age';
        }

        return (
            <td>
                <p>{kycSupportString}</p>
            </td>
        )
    }

    get kybSupport() {
        const { bvSupport, bvPlusSupport } = this.props;
        let kybSupportString = '';

        if (bvSupport && bvPlusSupport) {
            kybSupportString += 'BV & BV+';
        } else if (bvSupport) {
            kybSupportString = 'BV';
        } else if (bvPlusSupport) {
            kybSupportString = 'BV+'
        } else {
            kybSupportString = 'None';
        }

        return (
            <td>
                <p>{kybSupportString}</p>
            </td>
        )
    }

    get lastUpdated() {
        const { lastUpdated, countriesSortKey } = this.props;

        let classnames = ""
        if (countriesSortKey === CountrySortFields.LAST_UPDATED) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <LastUpdated lastUpdated={lastUpdated} type="medium" />
            </td>
        )
    }

    render() {

        return (
            <tr>
                {this.checkbox}
                {this.countryName}
                {this.kycSupport}
                {this.kybSupport}
                {this.lastUpdated}
            </tr>
        )
    }

}

const mapStateToProps = (state) => ({
    countriesSortKey: state.veritas.countries.countriesSortKey,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CountriesListRow)
